export default __webpack_public_path__ + "static/step-2-2e4bf20f33ec088b1831b8e0bc1ee694.png";